







































































































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { GlobalOnlyUploadService } from "@common/service/data-service/upload";
import { exportFileUrlNew } from "@common/utils/downloadFile";
import moment from "moment";

@Component({})
export default class DrawerScanForm extends Vue {
  @Prop({ type: Boolean, default: false })
  drawer;
  @Prop()
  scanData;

  dataOne: any[] = [];
  dataTwo: any[] = [];
  dataThree: any[] = [];
  tableData: any[] = [];
  license = "";

  @Watch("drawer", { immediate: false, deep: true })
  dealData() {
    this.dataOne = this.scanData[0];
    this.dataTwo = this.scanData[1];
    this.dataThree = this.scanData[2];
    // GlobalOnlyUploadService.download(
    //   this.scanData[0].slice(11, 12)[0].data[0].id
    // ).then((res: any) => {
    //   this.license = res.data;
    // });

    const arr: any[] = [
      {
        name: "公司营业额",
        bLastData: `${this.dataTwo[0].data} ${this.dataOne.slice(15, 16)[0].data}`,
        lastDatta: `${this.dataTwo[1].data} ${this.dataOne.slice(15, 16)[0].data}`,
        nowData: `${this.dataTwo[2].data} ${this.dataOne.slice(15, 16)[0].data}`
      },
      {
        name: "利润率",
        bLastData: `${this.dataTwo[3].data}%`,
        lastDatta: `${this.dataTwo[4].data}%`,
        nowData: `${this.dataTwo[5].data}%`
      }
    ];
    this.tableData = arr;
  }

  handleClose() {
    this.$emit("handleClose");
  }
  handleSubmit() {
    this.$emit("handleSubmit");
  }
  dealAddress(data: any) {
    const { province, city, district, detail } = data;
    return `${province}${city}${district}${detail}`;
  }
  handleDownLoad(data: any) {
    GlobalOnlyUploadService.download(data[0].id).then((res: any) => {
      exportFileUrlNew(res.data, data.name);
    });
  }
  changeTime(time: string) {
    return moment(time).format("YYYY-MM-DD");
  }
}
